import { Component } from 'react';
import ReactModal from '../../../../components/Modal';
import { bulkUpdateProject, updateKeyword } from '../query';
import Loading from '../../../../components/Loading';
import ReactSelect from '../../../../components/ReactSelect';
import { withTranslation } from 'react-i18next';

class EditProject extends Component {
    constructor(props) {
        super();
        this.onOpenModal = this.onOpenModal.bind(this);
        this.onCloseModal = this.onCloseModal.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.handleChangeSelect = this.handleChangeSelect.bind(this);

        this.state = {
            isOpen: false,
            selectedProject: props?.item?.project?.id,
            loading: false,
        };
    }

    onOpenModal() {
        this.setState({
            isOpen: true,
        });
    }
    onCloseModal() {
        this.setState({
            isOpen: false,
        });
    }

    async onSubmit(e) {
        try {
            e.preventDefault();
            this.setState({
                loading: true,
            });
            const params = {
                project: this.state.selectedProject,
            };

            if (this.props.isBulk) {
                params.ids = this.props.selectedItems;
                await bulkUpdateProject(params);
            } else {
                await updateKeyword(this.props?.item?.id, params);
            }
            this.props.getKeywords();
            this.setState({
                loading: false,
            });
            this.onCloseModal();
        } catch (err) {
            this.setState({
                loading: false,
            });
        }
    }

    handleChangeSelect(value) {
        this.setState({ selectedProject: value });
    }

    render() {
        const { t } = this.props;

        const projectOptions = this.props.projects?.map((project) => ({
            value: project.id,
            label: project.name,
        }));

        return (
            <>
                {this.props.isBulk ? (
                    <button
                        className={'table-additional-view-btn '}
                        disabled={this.props.selectedItems.length === 0}
                        onClick={this.onOpenModal}
                    >
                        Change Project
                    </button>
                ) : (
                    <div className="ai-tracking-edit-btn edit-project-btn">
                        <button
                            className="table-action-main-btn"
                            onClick={this.onOpenModal}
                            style={{ maxHeight: '40px' }}
                        >
                            <i className="icon-pencil"></i>
                        </button>
                    </div>
                )}

                <ReactModal modalState={this.state.isOpen} className="width-sm ai-tracking-modal">
                    <h3>{t('ai_tracking.keyword_manager.edit_project.header')}</h3>
                    <form onSubmit={this.onSubmit}>
                        <div className="ai-tracking-projects-keywords ai-tracking-modal-body">
                            <ReactSelect
                                options={projectOptions}
                                value={projectOptions.find(
                                    (x) => x.value === this.state.selectedProject,
                                )}
                                isSearchable={false}
                                onChange={this.handleChangeSelect}
                                blurInputOnSelect={true}
                                classname="mr-10"
                            />
                        </div>
                        <div className="ai-tracking-modal-footer">
                            <button
                                className="button button-filled button-primary width-sm btn  d-flex gap-5 align-items-center justify-content-center"
                                disabled={this.state.loading}
                                style={{ lineHeight: 'unset', marginRight: '10px' }}
                            >
                                {this.state.loading && <Loading onlyPreloader />}

                                {t('ai_tracking.keyword_manager.edit_project.save')}
                            </button>
                            <button
                                type="button"
                                className="button button-outline button-primary width-sm btn"
                                onClick={this.onCloseModal}
                                style={{ lineHeight: 'unset' }}
                            >
                                {t('ai_tracking.keyword_manager.edit_project.close')}
                            </button>
                        </div>
                    </form>
                </ReactModal>
            </>
        );
    }
}

export default withTranslation()(EditProject);
